//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import page from '~/plugins/mixins/page';

export default {
  auth: false,
  mixins: [page],
};
